import { styled } from '@mui/material/styles';

import {
  GRID_AREA_TITLE,
  GRID_AREA_SUBTITLE,
} from 'applications/GSP/layouts/MainLayout/components/Sidebar/components/components/Menu/components/MenuItem/constants';
import { GRID_AREA_STUDENT_AVATAR } from 'applications/GSP/layouts/MainLayout/components/Sidebar/components/components/StudentSection/components/StudentAvatar';
import { MenuItem } from 'shared/components/MenuItem';

export const Wrapper = styled(MenuItem)(({ theme }) => ({
  display: 'grid',
  gridTemplateAreas: `
    "${GRID_AREA_STUDENT_AVATAR} ${GRID_AREA_TITLE}"
    "${GRID_AREA_STUDENT_AVATAR} ${GRID_AREA_SUBTITLE}"
  `,
  columnGap: theme.spacing(2),
  alignItems: 'center',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));
